const ripleyCard = 'Tarjeta Ripley';
const chek = 'Chek';
const creditCard = 'Tarjeta de crédito';
const debitCard = 'Tarjeta de débito';

export const cancelPurchaseMapper = new Map([
  [
    ripleyCard,
    'La reversa se realizará en un plazo de 7 a 10 días hábiles contados desde el día siguiente a tu solicitud de nota de crédito.',
  ],
  [
    chek,
    'Debes revisar si cuentas con el suficiente cupo para que podamos realizar la devolución de tu dinero.',
  ],
  [
    creditCard,
    'La reversa se realizará en un plazo de 10 a 15 días hábiles contados desde el día siguiente a tu solicitud de nota de crédito.',
  ],
  [
    debitCard,
    'La reversa se realizará en un plazo de 10 a 15 días hábiles contados desde el día siguiente a tu solicitud de nota de crédito.',
  ],
]);

export const OPTIONS = [
  {
    id: ripleyCard,
    name: ripleyCard,
  },
  {
    id: chek,
    name: chek,
  },
  {
    id: creditCard,
    name: creditCard,
  },
  {
    id: debitCard,
    name: debitCard,
  },
];

const chileBank = 'BANCO DE CHILE/EDWARD/CITIBANK/CREDICHILE';
const internationalBank = 'BANCO INTERNACIONAL';
const continentalBank = 'BANCO CONTINENTAL';
const stateBank = 'BANCO DEL ESTADO DE CHILE';
const scotiabank = 'SCOTIABANK SUD AMERICANO';
const bci = 'BANCO DE CREDITO E INVERSIONES';
const brasilBank = 'BANCO DO BRASIL S.A';
const centralBank = 'BANCO CENTRAL';
const bice = 'BANCO BICE';
const hsbc = 'HSBC BANK (CHILE)';
const bankOfAmerica = 'BANK OF AMERICA';
const santander = 'BANCO SANTANDER';
const outsideBank = 'BANCO EXTERIOR S.A';
const itau = 'BANCO ITAU/CORPBANCA';
const sudameris = 'SUDAMERIS';
const jpmorgan = 'JP MORGAN CHASEBANK N.A';
const americanExpress = 'BANCO AMERICAN EXPRESS BANK';
const argentinaBank = 'BANCO DE LA NACION ARGENTINA';
const security = 'BANCO SECURITY';
const falabella = 'BANCO FALABELLA';
const ripley = 'BANCO RIPLEY';
const consorcio = 'BANCO CONSORCIO';
const penta = 'BANCO PENTA';
const paris = 'BANCO PARIS';
const bbva = 'BANCO BBVA';
const desarrollo = 'BANCO DEL DESARROLLO';
const conosur = 'BANCO CONOSUR';

export const BANK_OPTIONS = [
  {
    name: chileBank,
    id: chileBank,
  },
  {
    name: internationalBank,
    id: internationalBank,
  },
  {
    name: continentalBank,
    id: continentalBank,
  },
  {
    name: stateBank,
    id: stateBank,
  },
  {
    name: scotiabank,
    id: scotiabank,
  },
  {
    name: bci,
    id: bci,
  },
  {
    name: brasilBank,
    id: brasilBank,
  },
  {
    name: centralBank,
    id: centralBank,
  },
  {
    name: bice,
    id: bice,
  },
  {
    name: hsbc,
    id: hsbc,
  },
  {
    name: bankOfAmerica,
    id: bankOfAmerica,
  },
  {
    name: santander,
    id: santander,
  },
  {
    name: outsideBank,
    id: outsideBank,
  },
  {
    name: itau,
    id: itau,
  },
  {
    name: sudameris,
    id: sudameris,
  },
  {
    name: jpmorgan,
    id: jpmorgan,
  },
  {
    name: americanExpress,
    id: americanExpress,
  },
  {
    name: argentinaBank,
    id: argentinaBank,
  },
  {
    name: security,
    id: security,
  },
  {
    name: falabella,
    id: falabella,
  },
  {
    name: ripley,
    id: ripley,
  },
  {
    name: consorcio,
    id: consorcio,
  },
  {
    name: penta,
    id: penta,
  },
  {
    name: paris,
    id: paris,
  },
  {
    name: bbva,
    id: bbva,
  },
  {
    name: desarrollo,
    id: desarrollo,
  },
  {
    name: conosur,
    id: conosur,
  },
];
